import { useEffect, useRef, useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { X, Search, Check2Square, List, DashCircle } from "react-bootstrap-icons";
import { getUserList4Modal } from "../../BaseInfo/store/api/Users";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const ModalSelectUser = (props) => {
    const inputUserName = useRef();
    const selectedIDs = useRef([]);
    const tblResult = useRef();
    const { popData, setUserPop } = props;
    const [userList, setUserList] = useState([]);
    const { selectUser, selectUserWithName, show, filterOnCurrentUser } = popData;
    const search = () => {
        getUserList4Modal(inputUserName.current.value, setUserList, filterOnCurrentUser??false);
    }
    const setSelectedIDs = (add, id) => {
        if (add) {
            selectedIDs.current.push(id);

        }
        else {
            let indx = selectedIDs.current.indexOf(id);
            selectedIDs.current.splice(indx, 1);
        }
    }
    function close() {
        if (selectUser) {
            selectUser([]);

        }
        if (selectUserWithName) {
            selectUserWithName(null);
        }
        selectedIDs.current = [];
        setUserPop({ show: false });
    }
    const select = () => {
        if (selectUser) {
            selectUser([...selectedIDs.current]);

        }
        if (selectUserWithName) {
            if (selectedIDs.current.length > 0) {
                const id = selectedIDs.current.pop();
                const user = userList.find(u => u.ID === id);
                selectUserWithName(user);
            }
        }
        selectedIDs.current = [];
        setUserPop({ show: false });
    }
    function searchNameKeyDown(e) {
        if (e.key === "Enter") {
            search();
        }
        else if (e.keyCode === 27) {
            close();
        }
    }
    function selectAll(e) {
        for (let i = 1; i < tblResult.current.rows.length; i++) {
            const row = tblResult.current.rows[i];
            const chk = row.querySelector("input[type=checkbox]");
            chk.checked = e.target.checked;
            const userID = row.getAttribute("userid");
            if(chk.checked)
            {
                if (!selectedIDs.current.includes(userID)) {
                    selectedIDs.current.push(userID);
                }
                
            }
            else {
                let indx = selectedIDs.current.indexOf(userID);
                selectedIDs.current.splice(indx, 1);
            }
        }
    }
    useEffect(() => {
        if (show) {
            inputUserName.current.focus();
        }
    }, [show]);
    return (
        <Modal show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className="headerStyle"><span><List color="white" size={22} />&nbsp;لیست کاربران</span><FontAwesomeIcon icon={faTimes} size="lg" onClick={close} /></Modal.Header>
            <Modal.Body className="bodyStyle">
                <div className="form-group">
                    <input ref={inputUserName} type="text" className="form-control" placeholder="نام کاربر" onKeyDown={searchNameKeyDown} />
                    <Button className="btn-input-tiny" style={{ position: "absolute", top: "2px", left: "2px" }} onClick={search}><Search size={22} /></Button>
                </div>
                {userList &&
                    <Table responsive className="fixedTable mt-2" ref={tblResult}>
                        <thead>
                            <tr>
                                <th style={{ width: "20%", padding: "5px", paddingRight: "7px" }}>
                                    {!selectUserWithName && <input type="checkbox" className="form-check-input" onChange={selectAll}/>}&nbsp; انتخاب
                                    </th>
                                <th style={{ width: "80%", padding: "5px" }}>نام کاربر</th>

                            </tr>
                        </thead>
                        <tbody>
                            {userList && Array.isArray(userList) && userList.map((item, i) => {
                                return (
                                    <tr key={i} className="resultTableRow" userid={item.ID}>
                                        <td style={{ width: "20%" }}>
                                            {!selectUserWithName && <input type="checkbox" className="form-check-input" style={{ cursor: "pointer" }} onChange={(e) => setSelectedIDs(e.target.checked, item.ID)} />}
                                            {selectUserWithName && <input type="radio" name="radio" className="form-check-input" style={{ cursor: "pointer" }} onChange={(e) => setSelectedIDs(e.target.checked, item.ID)} />}
                                            </td>
                                        <td style={{ width: "80%" }}>{item.Name}</td>
                                    </tr>)
                            }
                            )}
                        </tbody>
                    </Table>
                }

                <div>
                    <Button className="group-Btn" variant="success" onClick={select}><Check2Square size={14} />&nbsp;انتخاب&nbsp;</Button>
                    <Button className="group-Btn" variant="danger" onClick={close}><DashCircle size={14} />&nbsp;انصراف&nbsp;</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectUser;